import { Tabs } from "antd";
import styled from "styled-components";

export const Styled = styled.div`
  & {
    height: 100%;
  }
  .rg-custom-cell {
    z-index: -1;
  }
  .rg-pane.rg-pane-center-middle {
    z-index: 1;
  }
  .rg-pane.rg-pane-top.rg-pane-left.rg-pane-shadow.shadow-top-left-corner {
    z-index: 11;
  }

  .rg-pane.rg-pane-top,
  .rg-pane.rg-pane-left {
    z-index: 10;
  }
`;

export const TabStyled = styled(Tabs)`
  .ant-tabs-nav {
    border-bottom: unset !important;
  }
  .ant-tabs-tab {
    height: 20px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom: 1px solid #bcbcbc;
  }
  .ant-tabs-nav-more {
    padding: 0px !important;
    height: 20px;
    background: #fff !important;
  }
`;
